module.exports = __webpack_public_path__ + "img/happy_hero.3de1bc5f.png";